import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Message } from 'primeng/components/common/message';
import { ConfirmationService } from "primeng/components/common/confirmationservice";
import { InterestModel } from './../../../../models/inModels/Interest';
import { AuthenticationService } from '../../../../services/authentication/authentication.service';
import { InterestsService } from '../../../../services/business/interests.service';

@Component({
  selector: 'app-interests-create',
  templateUrl: './interests-create.component.html',
  styleUrls: ['./interests-create.component.css']
})
export class InterestsCreateComponent {
  model: InterestModel;
  loading: boolean = false;
  error: Message[];
  uploading = false;
  constructor(private auth: AuthenticationService,
    private interestService: InterestsService,
    private router : Router,
    private confirmationService: ConfirmationService,) { 
      this.model = new InterestModel();
    }

    goBack(): void {
      this.router.navigate(['/interests']);
    }
    
    save(): void {
      console.log(this.model);
      this.loading = true;
      this.interestService.create(this.model).then(
        result => {
          this.loading = false;
          this.goBack();
        },
        error => {
          this.loading = false;
          this.error = [];
          this.error.push({ severity: 'error', summary: 'Error', detail: error });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/sales/interests/interests-create/interests-create.component.ts